'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './quickbooks-list.routes';

export class QuickbooksListComponent {
  constructor(IntegrationService) {
    'ngInject';

    IntegrationService.queryQuickbookBalances(data => {
      this.data = data;

      let balance = 0;
      this.data.forEach(entry => balance += entry.amount);

      this.balance = balance;
    });
  }
}

export default angular.module('conduu.quickbooksList', [uiRouter])
  .config(routes)
  .component('quickbooksList', {
    template: require('./quickbooks-list.html'),
    controller: QuickbooksListComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/user/quickbooks-list/quickbooks-list.component.js